export default () => {
     const moreInfoBtns = document.querySelectorAll('.js-showMoreInfoBtn');
     const moreInfoRows = document.querySelectorAll('.js-showMoreInfoRow');
     const fadeInBtn = document.querySelector('.js-FadeIn');
     const rotateSvg = document.querySelector('.js-Rotate');

     if(moreInfoBtns){
        moreInfoBtns.forEach(moreInfoBtn => {
            moreInfoBtn.addEventListener('click', () => {
                if(moreInfoRows){
                    moreInfoRows.forEach(moreInfoRow => {
                        moreInfoRow.classList.toggle('is-active');
                    });
                }
                moreInfoBtn.classList.toggle('is-reduced');

                    fadeInBtn.classList.toggle('fade-out');
                    rotateSvg.classList.toggle('rotate-center');

            })
        });
     }
}